export default {
    yes: "Sí",
    no: "No"
}